var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrgUpdated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 27,
    viewBox: "0 0 35 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3429 17.2581H32.087C32.465 17.2581 32.7149 17.5376 32.7149 17.8147V25.1731C32.7149 25.4502 32.465 25.7297 32.087 25.7297H20.3429C19.9649 25.7297 19.7149 25.4502 19.7149 25.1731V17.8147C19.7149 17.5376 19.9649 17.2581 20.3429 17.2581Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9592 18.3429H21.4706C21.1592 18.3429 20.9067 18.5794 20.9067 18.8712V24.117C20.9067 24.4087 21.1592 24.6452 21.4706 24.6452H30.9592C31.2707 24.6452 31.5232 24.4087 31.5232 24.117V18.8712C31.5232 18.5794 31.2707 18.3429 30.9592 18.3429Z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.12793 17.2581H12.8721C13.2501 17.2581 13.5 17.5376 13.5 17.8147V25.1731C13.5 25.4502 13.2501 25.7297 12.8721 25.7297H1.12793C0.749919 25.7297 0.5 25.4502 0.5 25.1731V17.8147C0.5 17.5376 0.749919 17.2581 1.12793 17.2581Z",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7443 18.3429H2.2557C1.94425 18.3429 1.69177 18.5794 1.69177 18.8712V24.117C1.69177 24.4087 1.94425 24.6452 2.2557 24.6452H11.7443C12.0557 24.6452 12.3082 24.4087 12.3082 24.117V18.8712C12.3082 18.5794 12.0557 18.3429 11.7443 18.3429Z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1279 0.5H22.8721C23.2501 0.5 23.5 0.77952 23.5 1.05664V8.41504C23.5 8.69216 23.2501 8.97168 22.8721 8.97168H11.1279C10.7499 8.97168 10.5 8.69216 10.5 8.41504V1.05664C10.5 0.77952 10.7499 0.5 11.1279 0.5Z",
    stroke: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7443 1.58484H12.2557C11.9442 1.58484 11.6917 1.82136 11.6917 2.11311V7.35889C11.6917 7.65065 11.9442 7.88717 12.2557 7.88717H21.7443C22.0557 7.88717 22.3082 7.65065 22.3082 7.35889V2.11311C22.3082 1.82136 22.0557 1.58484 21.7443 1.58484Z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27 13L6 13L16.5 13L27 13Z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18.3393L7 12L7 15.1697L7 18.3393Z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18.3393L26 12L26 15.1697L26 18.3393Z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.5396L17 7.20032L17 10.37L17 13.5396Z",
    stroke: "currentColor",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgUpdated);
export default __webpack_public_path__ + "static/media/org_updated.eda38223069bd98fe9e3bcd67fc76a91.svg";
export { ForwardRef as ReactComponent };